const c = /^(\d{2})\/(\d{2})\/(\d{4})$/, s = "-", m = {
  parse: (t, r) => {
    if (!t)
      return;
    const n = t.match(c);
    if (n)
      return r(n[3], n[2], n[1]);
  },
  format: (t) => {
    if (!t)
      return "";
    const r = t.getDate().toString(10).padStart(2, "0"), n = (t.getMonth() + 1).toString(10).padStart(2, "0"), o = t.getFullYear().toString(10);
    return `${r}/${n}/${o}`;
  }
}, e = (t, r, n) => t == null ? void 0 : t.split(r).reverse().map((o) => o.trim()).join(n), d = (t, r = "/") => e(t, r, s), i = (t, r = "/") => e(t, s, r);
export {
  m as dateAdapter,
  d as dmyToYmd,
  i as ymdToDmy
};
